import { render, staticRenderFns } from "./HotelInitPay.vue?vue&type=template&id=5b2b9ddc&scoped=true"
import script from "./HotelInitPay.vue?vue&type=script&lang=js"
export * from "./HotelInitPay.vue?vue&type=script&lang=js"
import style0 from "./HotelInitPay.vue?vue&type=style&index=0&id=5b2b9ddc&prod&lang=scss&scoped=true"
import style1 from "./HotelInitPay.vue?vue&type=style&index=1&id=5b2b9ddc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2b9ddc",
  null
  
)

export default component.exports